module.exports = __webpack_public_path__ + "public/images/slider/oleynikova-circle.53a6126de1c050fd75ad8a3ede8c3bc0.png";